import React from 'react';
import { Tag, TagProps } from '../ContentCard/Tag/Tag';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { ContentfulImage, ContentfulImageProps } from '../ContentfulImage/ContentfulImage';
import { styles } from './SideBySide.css';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { YoutubePlayer, YoutubePlayerProps } from '../YouTubePlayer/YouTubePlayer';
import { ContentfulRichText } from '@jbhi-fi/apis/src/contentful/types';
import { GoToLink, GoToLinkProps } from '../GoToLink/GoToLink';
import { VideoPlayer, VideoPlayerProps } from '../VideoPlayer/VideoPlayer';
import { breakpointSizePx } from '@jbhi-fi/lanyard-ui/themes';

export type SideBySideProps = {
  heading?: string;
  tagProps?: TagProps;
  ctaButtonProps?: Omit<GoToLinkProps, 'className'>;
  body?: ContentfulRichText;
  youTubeProps?: YoutubePlayerProps;
  imageProps?: ContentfulImageProps;
  videoProps?: VideoPlayerProps;
  isReversed?: boolean;
};

export const SideBySide = ({
  heading,
  tagProps,
  ctaButtonProps,
  body,
  youTubeProps,
  imageProps,
  videoProps,
  isReversed = false,
}: SideBySideProps) => {
  return (
    <div className={styles.container({ reverse: isReversed })}>
      <div className={styles.column({ wide: Boolean(youTubeProps || videoProps) })}>
        {imageProps ? (
          <ContentfulImage
            fillParent
            className={styles.image}
            {...imageProps}
            sizes={`(max-width: ${breakpointSizePx.md}px) 100vw, 50vw`}
          />
        ) : null}
        {youTubeProps ? <YoutubePlayer {...youTubeProps} /> : null}
        {videoProps ? <VideoPlayer height="unset" {...videoProps} /> : null}
      </div>
      <div className={classNames([styles.column(), styles.content])}>
        {tagProps ? <Tag {...tagProps} className={classNames([tagProps.className, styles.tag])} /> : null}
        {heading ? <h2 className={styles.heading}>{heading}</h2> : null}
        {body ? <div className={styles.body}>{documentToReactComponents(body)}</div> : undefined}
        {ctaButtonProps ? <GoToLink {...ctaButtonProps} /> : null}
      </div>
    </div>
  );
};
